import { application } from "./application";
import DependentSelectController from "./dependent_select_controller";
import DashboardSelectController from "./dashboard_select_controller";
import ChoicesMultiSelectController from "./choices_multi_select_controller";
import SelectboxController from "./selectbox_controller";
import PopupController from "./popup_controller";
import DashboardDatepickrLabelController from "./dashboard_datepickr_label_controller";
import SignageParentController from "./signage_parent_controller";
import SignageSlideHeaderController from "./signage_slide_header_controller";
import SignagePlaybackPanelController from "./signage_playback_panel_controller";
import SignageScreenController from "./signage_screen_controller";
import CostCalculatorController from "./cost_calculator_controller";
import ChecklistsByResourceController from "./checklists_by_resource_controller";
import ModalController from "./modal_controller";
import SelectAllCheckBoxesController from "./select_all_checkboxes_controller";
import CheckboxRevealController from "./checkbox_reveal_controller";
import ResourcePanelController from "./resource_panel_controller";
import AdvancedSearchModalController from "./advanced_search_modal_controller";
import GpsController from "./gps_controller";
import NotificationValidatorController from "./notification_validator_controller";
import InspectionQrCodesFormController from "./inspection_qr_codes_form_controller";
import NestedCheckBoxControllerr from "./nested_checkbox_controller";
import DateOffsetController from "./date_offset_controller";
import ImageUploadController from "./image_upload_controller";
import CsvUploadController from "./csv_upload_controller";
import MonthlyPeriodSelectController from "./monthly_period_select_controller";
import DateRangeValidationController from "./date_range_validation_controller";
import CheckboxBulkSelectController from "./checkbox_bulk_select_controller";
import InspectionsReportFormController from "./inspections_report_form_controller";
import InspectionsSearchFormController from "./inspections_search_form_controller";
import RecordedLinkController from "./recorded_link_controller";
import DataExportFormController from "./data_export_form_controller";
import DataExportButtonController from "./data_export_button_controller";
import RailsNestedForm from "@stimulus-components/rails-nested-form";
import Dropdown from "@stimulus-components/dropdown";

application.register("dependent-select", DependentSelectController);
application.register("dashboard-select", DashboardSelectController);
application.register("choices-multi-select", ChoicesMultiSelectController);
application.register("selectbox", SelectboxController);
application.register("popup", PopupController);
application.register("recorded-link", RecordedLinkController);
application.register("dashboard-datepickr-label", DashboardDatepickrLabelController);
application.register("signage-parent", SignageParentController);
application.register("signage-slide-header", SignageSlideHeaderController);
application.register("signage-playback-panel", SignagePlaybackPanelController);
application.register("signage-screen", SignageScreenController);
application.register("cost-calculator", CostCalculatorController);
application.register("checklists-by-resource", ChecklistsByResourceController);
application.register("modal", ModalController);
application.register("select-all-checkboxes", SelectAllCheckBoxesController);
application.register("checkbox-reveal", CheckboxRevealController);
application.register("resource-panel", ResourcePanelController);
application.register("advanced-search-modal", AdvancedSearchModalController);
application.register("gps", GpsController);
application.register("notification-validator", NotificationValidatorController);
application.register("inspection-qr-codes-form", InspectionQrCodesFormController);
application.register("nested-checkbox", NestedCheckBoxControllerr);
application.register("date-offset", DateOffsetController);
application.register("image-upload", ImageUploadController);
application.register("csv-upload", CsvUploadController);
application.register("monthly-period-select", MonthlyPeriodSelectController);
application.register("date-range-validation", DateRangeValidationController);
application.register("nested-form", RailsNestedForm);
application.register("dropdown", Dropdown);
application.register("checkbox-bulk-select", CheckboxBulkSelectController);
application.register("inspections-report-form", InspectionsReportFormController);
application.register("inspections-search-form", InspectionsSearchFormController);
application.register("data-export-form", DataExportFormController);
application.register("data-export-button", DataExportButtonController);
